export default "__VITE_ASSET__2f30513b__"